const DATE_FORMATS_BY_LANG = {
  es: 'DD/MM/YYYY',
  en: 'MMMM D, YYYY'
};

const DATETIME_FORMATS_BY_LANG = {
  es: 'DD/MM/YYYY HH:mm:ss',
  en: 'MMMM D, YYYY HH:mm:ss'
};

const getDateFormatByLocale = lang => {
  const format = DATE_FORMATS_BY_LANG[lang];
  return format || DATE_FORMATS_BY_LANG.es;
};

const getDateTimeFormatByLocale = lang => {
  const format = DATETIME_FORMATS_BY_LANG[lang];
  return format || DATETIME_FORMATS_BY_LANG.es;
};

const getDateValue = fecha => {
  if (fecha) {
    return fecha.format(DATE_FORMATS_BY_LANG.es);
  }
  return null;
};

const getDateTimeValue = fecha => {
  if (fecha) {
    return fecha.format(DATETIME_FORMATS_BY_LANG.es);
  }
  return null;
};

export {
  getDateFormatByLocale,
  getDateTimeFormatByLocale,
  getDateValue,
  getDateTimeValue,
  DATE_FORMATS_BY_LANG,
  DATETIME_FORMATS_BY_LANG
};
